// Light or dark, for the staff screens. Light by default; the choice is this
// browser's, kept in localStorage, because it follows the room (a dim back
// office, a bright hall) rather than the person.
//
// Set as data-ui-theme on <html>, not data-theme: the hall board's own dark scale
// answers to data-theme, and a machine's screen must never take its look from a
// choice somebody made at a desk.
export type Theme = 'light' | 'dark'

const KEY = 'qms-theme'

export function readTheme(): Theme {
  try {
    return localStorage.getItem(KEY) === 'dark' ? 'dark' : 'light'
  } catch {
    return 'light'
  }
}

export function applyTheme(theme: Theme) {
  document.documentElement.dataset.uiTheme = theme
  // HeroUI's dark variables answer to the class, not to data-ui-theme.
  document.documentElement.classList.toggle('dark', theme === 'dark')
}

export function saveTheme(theme: Theme) {
  applyTheme(theme)
  try {
    localStorage.setItem(KEY, theme)
  } catch {
    // A private window: the choice still holds for this visit.
  }
}
